import i18n from '@/lang';
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import { deepCopy } from '@/utils/utils';
var CACHEFROM = 'CacheFrom';
var VERSION = 'v4_7_0';
// 时间
var MONTHTIME = 2592000000;
var DAYTIME = 86400000;
var MINUTETIME = 60000;
var reg = /^Cache_Order_Receipt_/; // 工单回执的

var limitSwitch = false;
function CacheFrom() {
  var _isClass = this instanceof CacheFrom;
  this.fillNum = 0;
  this.version = VERSION;
  var oldData = JSON.parse(localStorage.getItem(CACHEFROM));
  this.cacheList = oldData || {
    version: this.version
  };
  if (!_isClass) {
    return new CacheFrom();
  }
}
CacheFrom.prototype.setCache = function (key, value) {
  if (_typeof(value) !== 'object' || !value) return new Error(i18n.tc("628"));
  if (!Object.keys(value).length) {
    return this.cacheList[key] = {};
  }
  var oldData = this.cacheList[key] || {};
  var data = _objectSpread(_objectSpread(_objectSpread({}, oldData), value), {}, {
    MaxAge: new Date().getTime() + MONTHTIME
  });
  this.cacheList[key] = data;
  this.setLocalCache(key);
};
CacheFrom.prototype.setLocalCache = function (key) {
  var bol = true;
  try {
    // 缓存满了的就清空表单缓存
    var strData = JSON.stringify(this.cacheList);
    localStorage.setItem(CACHEFROM, strData);
  } catch (_unused) {
    console.log('缓存满了');
    bol = false;
    if (!key) return;
    this.fillNum++; // 判断满了几次
    var data = deepCopy(this.cacheList[key]);
    this.clearCache();
    if (this.fillNum >= 1 && this.fillNum < 5) {
      // 满了1次以上 说明 表单缓存清除了还是满的  就缓存不成功了，
      this.setCache(key, data);
    }
  }
  if (bol && this.fillNum > 0) {
    // bol 是真说明缓存设置成功， 那如果慢过  就重置 说明还可以添加
    this.fillNum = 0;
  }
};
CacheFrom.prototype.updataCache = function () {
  this.cacheList = JSON.parse(localStorage.getItem(CACHEFROM)) || {
    version: this.version
  };
};
CacheFrom.prototype.getCache = function (key) {
  // if (!reg.test(key)) return null
  if (limitSwitch) return null;
  if (this.cacheList[key]) {
    var _this$cacheList$key;
    var isPastDue = (((_this$cacheList$key = this.cacheList[key]) === null || _this$cacheList$key === void 0 ? void 0 : _this$cacheList$key.MaxAge) || 0) <= Date.now();
    if (isPastDue) {
      this.removeCache(key);
    }
    this.filterPastDueCache();
  } else {
    return null;
  }
  return this.cacheList[key] || null;
};
CacheFrom.prototype.removeCache = function (key) {
  delete this.cacheList[key];
  this.filterPastDueCache();
  this.removeLocalCache();
};
CacheFrom.prototype.removeLocalCache = function () {
  this.setLocalCache();
};
CacheFrom.prototype.clearCache = function (key) {
  this.cacheList = {
    version: this.version
  };
  this.clearLocalCache();
};
CacheFrom.prototype.clearLocalCache = function () {
  localStorage.removeItem(CACHEFROM);
};
// 过滤过期缓存
CacheFrom.prototype.filterPastDueCache = function () {
  var _this = this;
  if (!this.cacheList.version || this.cacheList.version != this.version) {
    this.clearCache();
    return this.setLocalCache();
  }
  Promise.resolve().then(function (v) {
    // 使用微任务来清空过期的值
    var arrKey = Object.keys(_this.cacheList);
    var filterAfterCache = {};
    arrKey.forEach(function (val) {
      if (_this.cacheList[val].MaxAge > Date.now() || val === 'version') {
        // 未过期
        filterAfterCache[val] = _this.cacheList[val];
      }
    });
    _this.cacheList = filterAfterCache;
    _this.setLocalCache();
  });
};
CacheFrom.prototype.computedUse = function () {
  var cache = 0;
  for (var key in this.cacheList) {
    if (this.cacheList.hasOwnProperty(key)) {
      cache += roughSizeOfObject(this.cacheList[key]);
    }
  }
  return (cache / 1024).toFixed(2);
};
function roughSizeOfObject(object) {
  var objectList = [];
  var stack = [object];
  var bytes = 0;
  while (stack.length) {
    var value = stack.pop();
    if (typeof value === 'boolean') {
      bytes += 4;
    } else if (typeof value === 'string') {
      bytes += value.length * 2;
    } else if (typeof value === 'number') {
      bytes += 8;
    } else if (_typeof(value) === 'object' && objectList.indexOf(value) === -1) {
      objectList.push(value);
      for (var i in value) {
        stack.push(value[i]);
      }
    }
  }
  return bytes;
}
export default new CacheFrom();